import { getDeviceInfo } from "helpers/utils";
import { getUserToken } from "../helpers/authHelper";
import api from "../api";


export async function FetchOnboardedList(payload) {
  return await api({
    method: "get",
    params: payload,
    url: `${process.env.REACT_APP_API_URL}/admin/onboarded/onboarded-list`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || "",
    },
  });
}

export async function RejectPendingRecord(id) {
 return await api({
   method: "put",
   data: '',
   url: `${process.env.REACT_APP_API_URL}/admin/common/reject-application/${id}`,
   headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
 });
}
export async function updatestatus(appl_id, status,comment,status_change_from) {
  let authUser = JSON.parse(localStorage.getItem("authUser"));
  let user_id = authUser.user.id;
  let device_info = await getDeviceInfo(navigator)
  return await api({
    method: "put",
    url: `${process.env.REACT_APP_API_URL}/admin/common/update-status/${appl_id}`,
    data: { status, comment, user_id, status_change_from, device_info: device_info },
    headers: { Authorization: getUserToken(), "X-DomainID": localStorage.getItem("subdomainId") || "" },
  });
}